import constants from "../config/constants";

const $inject = ['$q', '$injector', '$rootScope', 'AUTH_EVENTS', 'dataSourceService'];

const authInterceptor = function ($q, $injector, $rootScope, AUTH_EVENTS, dataSourceService) {
  let factory = {};
  factory.request = request;
  factory.responseError = responseError;

  function request(config) {
    if (dataSourceService.dataSource === constants.DATA_SOURCES.ODATA) {
      let authService = $injector.get('authService');
      let accessToken = authService.getAccessToken();

      if (accessToken) {
        config.headers.Authorization = 'Bearer ' + accessToken;
      } else {
        $rootScope.$broadcast(AUTH_EVENTS.notAuthenticated);
      }
    }

    return config;
  }

  function responseError(rejection) {
    let deferred = $q.defer();

    if (rejection.status === 401 && dataSourceService.dataSource === constants.DATA_SOURCES.ODATA) {
      let authService = $injector.get('authService');
      let refreshToken = authService.getRefreshToken();

      if (refreshToken) {
        authService.refresh().then(function (response) {
          _retryHttpRequest(rejection.config, deferred);
        }, function () {
          authService.logout();
          deferred.reject(rejection);
        });
      }
      else {
        $rootScope.$broadcast(AUTH_EVENTS.notAuthenticated);
        deferred.reject(rejection);
      }
    } else {
      deferred.reject(rejection);
    }

    return deferred.promise;
  }

  return factory;
};

authInterceptor.$inject = $inject;

export default authInterceptor;



// WEBPACK FOOTER //
// ./src/factories/authInterceptor.js